import styled from 'styled-components';

export const Wrapper = styled.div`
  .sphereCard-headingOperates {
    visibility: hidden;
  }
  &:hover .sphereCard-headingOperates {
    visibility: visible;
  }
`;
